<script>
import { iBadge, iSpinner, iFeaturedIcon } from '@inscribe/signal';
import StatusBadge, {
  StatusStyles,
} from '@/V2/components/status/StatusBadge.vue';
import { Statuses } from '@/V2/components/status/utils';

export default {
  name: 'CustomerReviewStatusBadge',
  components: {
    iBadge,
    iSpinner,
    iFeaturedIcon,
    StatusBadge,
  },
  props: {
    isApproved: {
      type: [Boolean, null],
      required: false,
      default: null,
    },
    class: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      Statuses,
      StatusStyles,
    };
  },
  computed: {
    state() {
      switch (this.isApproved) {
        case true:
          return Statuses.SUCCESS;
        case false:
          return Statuses.ERROR;
        default:
          return Statuses.WARNING;
      }
    },
    label() {
      switch (this.isApproved) {
        case true:
          return 'Approved';
        case false:
          return 'Rejected';
        default:
          return 'Requires Review';
      }
    },
  },
};
</script>
<template>
  <div :class="class">
    <status-badge :type="StatusStyles.OUTLINE" :state="state" :label="label" />
  </div>
</template>
